module.exports = __webpack_public_path__ + "img/tik.48fc540.svg";